/* eslint react/prop-types: off */
import axios from 'axios';
import { createContext, useContext, useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
const ActualizarSiniestroContext = createContext();
export const useActualizarSiniestro = () => useContext(ActualizarSiniestroContext);
export const ActualizarSiniestroProvider = ({ children, denuncia, reclamos }) => {
  const [selectedOption, setSelectedOption] = useState(denuncia?.empleadoAsignado);
  const [fechaRec, setFechaRec] = useState(denuncia?.recepcionRecChoques);
  const [sicobeOption, setSicobeOption] = useState(denuncia?.cbtSicobe);
  const [responsabilidad, setResponsabilidad] = useState(denuncia?.catStro);
  const [descStro, setDescStro] = useState(denuncia?.descStro);
  const [prioridad, setPrioridad] = useState(denuncia?.prioridad);
  const [vencimiento, setVencimiento] = useState(denuncia?.fechaVencimiento);
  const [monto, setMonto] = useState(denuncia?.monto);
  const [comercial, setComercial] = useState(denuncia?.comercial);
  const [porcentaje, setPorcentaje] = useState(denuncia?.porcentaje);
  const [aceptacion, setAceptacion] = useState(denuncia?.aceptacion);
  const [ordenDePago, setOrdenDePago] = useState(denuncia?.ordenDePago);
  useEffect(() => {
    if (denuncia) {
      setSelectedOption(denuncia.empleadoAsignado);
      setFechaRec(denuncia.recepcionRecChoques);
      setSicobeOption(denuncia.cbtSicobe);
      setResponsabilidad(denuncia.catStro);
      setDescStro(denuncia.descStro);
      setPrioridad(denuncia.prioridad);
      setVencimiento(denuncia.fechaVencimiento);
      setMonto(denuncia.monto);
      setComercial(denuncia.comercial);
      setPorcentaje(denuncia.porcentaje);
      setAceptacion(denuncia.aceptacion);
      setOrdenDePago(denuncia.ordenDePago);
    }
  }, [denuncia]);
  // Estado y función para manejar los reclamos editados
  const [reclamosEditados, setReclamosEditados] = useState([]);
  useEffect(() => {
    if (reclamos?.length) {
      setReclamosEditados(prev => {
        // Creamos un mapa de los reclamos que ya existían
        const mapPrev = Object.fromEntries(prev.map(r => [r.id, r]));

        return reclamos.map(r => {
          if (mapPrev[r.id]) {
            // 🔹 Mantenemos todo lo que el usuario editó
            return { ...r, ...mapPrev[r.id] };
          }
          // 🔹 Si es nuevo, lo agregamos completo
          return r;
        });
      });
    }
  }, [reclamos]);

  const actualizarReclamo = (id, path, nuevoValor) => {
    setReclamosEditados(prev => {
      const copia = [...prev];
      const index = copia.findIndex(r => r.id === id);
      if (index === -1) return prev;
      const reclamo = copia[index];
      // Convertir path a array si es string
      const pathArray = typeof path === 'string' ? [path] : path;
      // Función para clonar el objeto hasta el nivel correcto y actualizar el valor
      function setDeepValue(obj, keys, value) {
        if (keys.length === 1) {
          return { ...obj, [keys[0]]: value };
        }
        const key = keys[0];
        return {
          ...obj,
          [key]: setDeepValue(obj[key] ?? {}, keys.slice(1), value),
        };
      }
      // Crear el nuevo objeto reclamo con el valor actualizado
      const reclamoActualizado = setDeepValue(reclamo, pathArray, nuevoValor);
      copia[index] = reclamoActualizado;
      return copia;
    });
  };
  //
  const today = new Date();
  let day = today.getDate();
  let month = today.getMonth() + 1;
  const year = today.getFullYear();
  day = day < 10 ? '0' + day : day;
  month = month < 10 ? '0' + month : month;
  const formattedDate = day + '/' + month + '/' + year;
  function getCurrentTime() {
    const now = new Date();
    let hour = now.getHours();
    let minute = now.getMinutes();
    minute = minute < 10 ? '0' + minute : minute;
    return hour + ':' + minute;
  }
  const currentTime = getCurrentTime();
  const [cookies] = useCookies(['user']);
  function getCambiosValores(valoresOriginales, valoresEditados, camposEstado) {
    let cambios = [];
    for (const estadoId in valoresEditados) {
      const valoresEdit = valoresEditados[estadoId] || {};
      const valoresOrig = valoresOriginales?.[estadoId] || {};
      const campos = camposEstado[estadoId] || [];
      for (const campoNombre in valoresEdit) {
        const valorNuevo = valoresEdit[campoNombre];
        const valorViejo = valoresOrig[campoNombre];
        if (valorNuevo !== valorViejo) {
          const campo = campos.find(c => c.nombre === campoNombre);
          const label = campo?.label || campoNombre;
          cambios.push(`${label}: ${valorNuevo ?? ''}`);
        }
      }
    }
    return cambios;
  }
  const guardarCambios = async () => {
    function formatearFechaHora(fechaISO) {
      const fecha = new Date(fechaISO);
      const pad = n => n.toString().padStart(2, '0');
      const dia = pad(fecha.getDate());
      const mes = pad(fecha.getMonth() + 1); // Enero = 0
      const anio = fecha.getFullYear();
      const horas = pad(fecha.getHours());
      const minutos = pad(fecha.getMinutes());
      const segundos = pad(fecha.getSeconds());
      return `${dia}/${mes}/${anio} ${horas}:${minutos}:${segundos}`;
    }
    for (let i = 0; i < reclamosEditados.length; i++) {
      const reclamo = reclamosEditados[i];
      const camposEstado = reclamo.camposEstado || {};
      const valores = reclamo.valores || {};
      const reclamoOriginal = reclamos.find(r => r.id === reclamo.id);
      if (reclamoOriginal && reclamo.estado !== reclamoOriginal.estado) {
        const nuevoEstadoId = reclamo.estado;
        const camposNuevoEstado = camposEstado[nuevoEstadoId] || [];
        if (camposNuevoEstado.length > 0) {
          const primerCampo = camposNuevoEstado[0];
          valores[nuevoEstadoId][primerCampo.nombre] = formatearFechaHora(new Date().toISOString());
        }
      }
      for (const estadoId in valores) {
        const valoresEstado = valores[estadoId] || {};
        const campos = camposEstado[estadoId] || [];
        let huboCambio = false;
        for (const campoNombre in valoresEstado) {
          const valor = valoresEstado[campoNombre];
          if (valor !== null && valor !== '') {
            huboCambio = true;
            break;
          }
        }
        if (huboCambio && campos.length > 0) {
          const primerCampo = campos[0];
          valores[estadoId][primerCampo.nombre] = formatearFechaHora(new Date().toISOString());
        }
      }
    }
    const payload = {
      siniestro: {
        id: denuncia.id,
        empleadoAsignado: selectedOption,
        recepcionRecChoques: fechaRec,
        cbtSicobe: sicobeOption,
        catStro: responsabilidad,
        descStro: descStro,
        prioridad: prioridad,
        fechaVencimiento: vencimiento,
        monto: monto,
        comercial: comercial,
        porcentaje: porcentaje,
        aceptacion: aceptacion,
        ordenDePago: ordenDePago,
      },
      reclamos: reclamosEditados,
    };
    try {
      await axios.post('https://back.agsseguros.online/api/prueba/actualizarSiniestroReclamoGlobal', payload);
      let cambios = [];
      if (selectedOption !== denuncia.empleadoAsignado) cambios.push(`Asignado: ${selectedOption}`);
      if (selectedOption !== denuncia.empleadoAsignado) {
        await axios.post(`https://back.agsseguros.online/api/mail/mailAsignado`, {
          id: denuncia.id,
          nroStro: denuncia.nroStro,
          entryId: denuncia.entryId,
          user: selectedOption,
        });
      }
      if (sicobeOption !== denuncia.cbtSicobe) cambios.push(`Cbt Sicobe: ${sicobeOption}`);
      if (sicobeOption !== denuncia.cbtSicobe && Number(sicobeOption) === 4) {
        await axios.post(`https://back.agsseguros.online/api/mail/sinCoberturaCobranzas`, {
          id: denuncia.id,
        });
      }
      if (fechaRec !== denuncia.recepcionRecChoques) cambios.push(`F. Rec Recibido: ${fechaRec}`);
      if (prioridad !== denuncia.prioridad) cambios.push(`Prioridad: ${prioridad}`);
      if (vencimiento !== denuncia.fechaVencimiento) cambios.push(`Vencimiento: ${vencimiento}`);
      if (monto !== denuncia.monto) cambios.push(`Monto: ${monto}`);
      if (comercial !== denuncia.comercial) cambios.push(`Comercial: ${comercial}`);
      if (porcentaje !== denuncia.porcentaje) cambios.push(`Porcentaje: ${porcentaje}`);
      if (aceptacion !== denuncia.aceptacion) cambios.push(`Aceptación: ${aceptacion}`);
      if (ordenDePago !== denuncia.ordenDePago) cambios.push(`Orden de Pago: ${ordenDePago}`);
      if (descStro !== denuncia.descStro) cambios.push(`Descripción Stro: ${descStro}`);
      if (cambios.length > 0) {
        await axios.post(`https://back.agsseguros.online/api/cronologia`, {
          id: denuncia.id,
          desc: `El usuario ha actualizado los siguientes valores:\n${cambios.join('\n')}`,
          obs: '',
          jerarquia: cookies.user.depto === 'cargas' ? 'CRG' : 'DEN',
          motivo: 'STRO',
          autor: cookies.user.usuario,
          fecha: formattedDate,
          hora: currentTime,
        });
      }
      for (let reclamoEditado of reclamosEditados) {
        const reclamoOriginal = reclamos.find(r => r.id === reclamoEditado.id);
        if (!reclamoOriginal) continue;
        let cambiosReclamo = [];
        if (reclamoEditado.catStro !== reclamoOriginal.catStro) cambiosReclamo.push(`Cat Stro: ${reclamoEditado.catStro}`);
        if (reclamoEditado.asignado !== reclamoOriginal.asignado) cambiosReclamo.push(`Asignado: ${reclamoEditado.asignado}`);
        if (reclamoEditado.estado !== reclamoOriginal.estado) cambiosReclamo.push(`Estado: ${reclamoEditado.estados.find(e => e.id === Number(reclamoEditado.estado)).nombre}`);
        if (reclamoEditado.monto !== reclamoOriginal.monto) cambiosReclamo.push(`Monto: ${reclamoEditado.monto}`);
        if (reclamoEditado.comercial !== reclamoOriginal.comercial) cambiosReclamo.push(`Comercial: ${reclamoEditado.comercial}`);
        if (reclamoEditado.porcentaje !== reclamoOriginal.porcentaje) cambiosReclamo.push(`Porcentaje: ${reclamoEditado.porcentaje}`);
        if (reclamoEditado.aceptacion !== reclamoOriginal.aceptacion) cambiosReclamo.push(`Aceptación: ${reclamoEditado.aceptacion}`);
        if (reclamoEditado.ordenDePago !== reclamoOriginal.ordenDePago) cambiosReclamo.push(`Orden de Pago: ${reclamoEditado.ordenDePago}`);
        if (reclamoEditado.fRecRecibido !== reclamoOriginal.fRecRecibido) cambiosReclamo.push(`F.Rec Recibido: ${reclamoEditado.fRecRecibido}`);
        if (reclamoEditado.obs !== reclamoOriginal.obs) cambiosReclamo.push(`Obs: ${reclamoEditado.obs}`);
        if (reclamoEditado.f15 !== reclamoOriginal.f15) cambiosReclamo.push(`F15: ${reclamoEditado.f15}`);
        const cambiosValores = getCambiosValores(reclamoOriginal.valores, reclamoEditado.valores, reclamoEditado.camposEstado);
        cambiosReclamo.push(...cambiosValores);
        if (reclamoEditado.asignado !== reclamoOriginal.asignado) {
          await axios.post(`https://back.agsseguros.online/api/mail/mailAsignadoReclamo`, {
            id: denuncia.id,
            nroStro: denuncia.nroStro,
            entryId: denuncia.entryId,
            user: reclamoEditado.asignado,
            catStro: reclamoEditado.catStro,
          });
        }
        if (cambiosReclamo.length > 0) {
          await axios.post('https://back.agsseguros.online/api/cronologia', {
            id: denuncia.id,
            desc: `El usuario ha actualizado los siguientes valores del reclamo #${reclamoEditado.catStro}:\n${cambiosReclamo.join('\n')}`,
            obs: '',
            jerarquia: cookies.user.depto === 'cargas' ? 'CRG' : 'DEN',
            motivo: 'STRO',
            autor: cookies.user.usuario,
            fecha: formattedDate,
            hora: currentTime,
          });
        }
      }
    } catch (error) {
      alert('Error al guardar: ' + (error.response?.data?.error || error.message));
    }
  };
  return (
    <ActualizarSiniestroContext.Provider
      value={{
        selectedOption,
        setSelectedOption,
        fechaRec,
        setFechaRec,
        sicobeOption,
        setSicobeOption,
        responsabilidad,
        setResponsabilidad,
        descStro,
        setDescStro,
        prioridad,
        setPrioridad,
        vencimiento,
        setVencimiento,
        monto,
        setMonto,
        comercial,
        setComercial,
        porcentaje,
        setPorcentaje,
        aceptacion,
        setAceptacion,
        ordenDePago,
        setOrdenDePago,
        reclamosEditados,
        actualizarReclamo,
        guardarCambios,
      }}>
      {children}
    </ActualizarSiniestroContext.Provider>
  );
};
